import Phaser from 'phaser'
// import GuideHandler from './guideHandler'
import GuideEditor from '../editor/guideEditor'
import Editable from './editable'
import { AVG_HOPSIZE, MIN_HOPSIZE, MAX_HOPSIZE } from '/components/levelGenerator'

export default class Guide extends Editable {
  constructor (scene, args, doSave = true) {
    super(scene, args, 'gui', doSave)

    this.removeProperty('x')
    this.removeProperty('y')

    this.bounce = false
    this.canMove = false

    this.editor = new GuideEditor(this.scene, this)
    this.addEditor(this.editor)

    this.graphics = this.scene.add.graphics()
    this.graphics.clear()
    this.graphics.lineStyle(100, 0xffffff, 1)
    this.graphics.setDepth(2)

    var nPoints = args.nPoints
    if (nPoints) {
      for (var i = 0; i < nPoints; i++) {
        var p = args['p' + i]
        this.addPoint(p.x, p.y, p.start)
      }
    }

    this.refresh()
  }

  refresh (offset = 0) {
    if (this.editor.points.length >= 2) {
      this.graphics.clear()
      // this.graphics.setTexture('white', 0) // THIS CRASHES THE GAME ON MOBILE
      this.graphics.lineStyle(100, 0xffffff, 1)
      this.graphics.fillStyle(0xFFFFFF, 1)
      // this.graphics.setDepth(2) // THIS CRASHES THE GAME ON MOBILE
      for (var i = 1; i < this.editor.points.length; i++) {
        var p0 = this.editor.getPoint(i - 1)
        var p1 = this.editor.getPoint(i)
        if (!p1.start) {
          this.drawCurve(p0.x - offset, p0.y, p1.x - offset, p1.y)
        }
      }

      // this.graphics.setAlpha(0.5)
    }
  }

  addPoint (x, y, start = false) {
    this.editor.addPoint(x, y, start)
    this.refresh()
  }

  addStart (x, y) {
    this.editor.addPoint(x, y, true)
    this.editor.addPoint(x + 600, y)
    this.refresh()
  }

  insertPoint (x, y) {
    this.editor.insertPoint(x, y)
    this.refresh()
  }

  getCurve (x0, y0, x1, y1) {
    const s = new Phaser.Math.Vector2(x0, y0)
    const c1 = new Phaser.Math.Vector2(x0 + 100, y0 - 700)
    const c2 = new Phaser.Math.Vector2(x1 - 100, y0 - 700)
    const e = new Phaser.Math.Vector2(x1, y1)

    c2.y -= (y1 - y0) * 0.4

    return new Phaser.Curves.CubicBezier(s, c1, c2, e)
  }

  getInnerMostCurve (x0, y0, x1, y1) {
    const s = new Phaser.Math.Vector2(x0 + 140, y0 - 80)
    const c1 = new Phaser.Math.Vector2(x0 + 200, y0 - 500)
    const c2 = new Phaser.Math.Vector2(x1 - 200, y0 - 500)
    const e = new Phaser.Math.Vector2(x1 - 140, y1 - 80)

    c2.y -= (y1 - y0) * 0.4
    e.y = Math.max(c2.y, e.y)

    return new Phaser.Curves.CubicBezier(s, c1, c2, e)
  }

  getInnerCurve (x0, y0, x1, y1) {
    const s = new Phaser.Math.Vector2(x0 + 75, y0)
    const c1 = new Phaser.Math.Vector2(x0 + 200, y0 - 515)
    const c2 = new Phaser.Math.Vector2(x1 - 200, y0 - 515)
    const e = new Phaser.Math.Vector2(x1 - 75, y1)

    c2.y -= (y1 - y0) * 0.4
    e.y -= Math.min(0, (y1 - y0)) * 0.25

    return new Phaser.Curves.CubicBezier(s, c1, c2, e)
  }

  getOuterCurveValues (x0, y0, x1, y1) {
    const s = new Phaser.Math.Vector2(x0, y0 - 320)
    const c1 = new Phaser.Math.Vector2(x0 + 150, y0 - 780)
    const c2 = new Phaser.Math.Vector2(x1 - 150, y0 - 780)
    const e = new Phaser.Math.Vector2(x1, y1 - 320)

    // USING SOME MAGIC NUMBERS,
    // Narrow/wider control points and lower/raise edge points,
    // depending on the width of the Hop:
    if (x1 - x0 < AVG_HOPSIZE) {
      // small hops need wider control points and higher edge points
      var r = 1 - (((x1 - x0) - MIN_HOPSIZE) / (AVG_HOPSIZE - MIN_HOPSIZE))
      s.y -= r * 130
      e.y -= r * 130
      c1.x -= r * 50
      c2.x += r * 50
      c1.y += r * 45
      c2.y += r * 45
    } else if (x1 - x0 > AVG_HOPSIZE) {
      // big hops need narrower control points and lower edge points
      var r = ((x1 - x0) - AVG_HOPSIZE) / (MAX_HOPSIZE - AVG_HOPSIZE)
      s.y += r * 40
      e.y += r * 40
      c1.x += r * 60
      c2.x -= r * 60
      c1.y -= r * 10
      c2.y -= r * 10
    }

    // Also narrow/wider control points and lower/raise edge points,
    // depending on the height-difference in the Hop:
    if (y1 < y0 - 20) {
      // hop goes up.
      c2.x -= 25
      c2.y -= (y1 - y0) * 0.35
      e.x -= 50
      e.y -= (y1 - y0) * 0.25
    } else if (y1 > y0 + 20) {
      // hop goes down.
      c2.y -= (y1 - y0) * 0.15
      e.y -= (y1 - y0) * 0.6
    }

    return { s, c1, c2, e }
  }

  getOuterMostCurve (x0, y0, x1, y1) {
    const values = this.getOuterCurveValues(x0, y0, x1, y1)

    // now, make it outerMOST:
    values.s.y -= 75
    values.s.x += 30
    values.e.y -= 75
    values.e.x -= 30
    values.c1.y += 40
    values.c2.y += 40
    values.c1.x += 20
    values.c2.x -= 20

    return new Phaser.Curves.CubicBezier(values.s, values.c1, values.c2, values.e)
  }

  getOuterCurve (x0, y0, x1, y1) {
    const values = this.getOuterCurveValues(x0, y0, x1, y1)
    return new Phaser.Curves.CubicBezier(values.s, values.c1, values.c2, values.e)
  }

  drawCurve (x0, y0, x1, y1) {
    // this.graphics.fillCircle(x0, y0, 50)

    this.graphics.lineStyle(100, this.scene.colorGuide, 1)
    var curve = this.getCurve(x0, y0, x1, y1)
    curve.draw(this.graphics, 512)

    // for debugging:
    // this.graphics.lineStyle(4, 0xff0000, 1)
    // curve = this.getOuterMostCurve(x0, y0, x1, y1)
    // curve.draw(this.graphics)

    // this.graphics.lineStyle(4, 0xff00ff, 1)
    // curve = this.getInnerCurve(x0, y0, x1, y1)
    // curve.draw(this.graphics)

    // this.graphics.lineStyle(4, 0x0000ff, 1)
    // curve = this.getInnerMostCurve(x0, y0, x1, y1)
    // curve.draw(this.graphics)
  }

  findTForXCurve (x0, x1, y0, y1, x) {
    const step = 0.001
    let prevX = x0
    for (var t = 0; t <= 1; t += step) {
      const pos = this.getCurveAt(x0, x1, y0, y1, t)
      if (prevX < x && pos.x >= x) {
        return t
      }
      prevX = pos.x
    }
    return 1
  }

  findTForXOuterCurve (x0, x1, y0, y1, x) {
    const step = 0.001
    let prevX = x0
    for (var t = 0; t <= 1; t += step) {
      const pos = this.getOuterCurveAt(x0, x1, y0, y1, t)
      if (prevX <= x && pos.x >= x) {
        return t
      }
      prevX = pos.x
    }
    return 1
  }

  findTForXOuterMostCurve (x0, x1, y0, y1, x) {
    const step = 0.001
    let prevX = x0
    for (var t = 0; t <= 1; t += step) {
      const pos = this.getOuterMostCurveAt(x0, x1, y0, y1, t)
      if (prevX <= x && pos.x >= x) {
        return t
      }
      prevX = pos.x
    }
    return 1
  }

  findTForXInnerCurve (x0, x1, y0, y1, x) {
    const step = 0.001
    let prevX = x0
    for (var t = 0; t <= 1; t += step) {
      const pos = this.getInnerCurveAt(x0, x1, y0, y1, t)
      if (prevX < x && pos.x >= x) {
        return t
      }
      prevX = pos.x
    }
    return 1
  }

  findTForXInnerMostCurve (x0, x1, y0, y1, x) {
    const step = 0.001
    let prevX = x0
    for (var t = 0; t <= 1; t += step) {
      const pos = this.getInnerMostCurveAt(x0, x1, y0, y1, t)
      if (prevX < x && pos.x >= x) {
        return t
      }
      prevX = pos.x
    }
    return 1
  }

  getCurveAt (x0, x1, y0, y1, t) {
    const curve = this.getCurve(x0, y0, x1, y1)
    var out = curve.getPoint(t)
    return out
  }

  getInnerMostCurveAt (x0, x1, y0, y1, t) {
    const curve = this.getInnerMostCurve(x0, y0, x1, y1)
    var out = curve.getPoint(t)
    return out
  }

  getInnerCurveAt (x0, x1, y0, y1, t) {
    const curve = this.getInnerCurve(x0, y0, x1, y1)
    var out = curve.getPoint(t)
    return out
  }

  getOuterCurveAt (x0, x1, y0, y1, t) {
    const curve = this.getOuterCurve(x0, y0, x1, y1)
    var out = curve.getPoint(t)
    return out
  }

  getOuterMostCurveAt (x0, x1, y0, y1, t) {
    const curve = this.getOuterMostCurve(x0, y0, x1, y1)
    var out = curve.getPoint(t)
    return out
  }

  getNearestPoint (x, y) {
    for (var i = 0; i < this.editor.points.length; i++) {
      if (this.editor.points[i].x > x) {
        return this.editor.points[i].y
      }
    }
    return y
  }

  // mapXOnCurve(){
  //
  // }

  // TODO: use proper y values, dont use handlers anymore
  getHeightAndTangentAtX (x) {
    var x0 = 0
    var x1 = 0
    for (var i = 1; i < this.handlers.length; i++) {
      if (this.handlers[i - 1].getX() < x && this.handlers[i].getX() >= x) {
        x0 = this.handlers[i - 1].getX()
        x1 = this.handlers[i].getX()
        break
      }
    }

    const s = new Phaser.Math.Vector2(x0, 620)
    const c1 = new Phaser.Math.Vector2(x0 + 100, -50)
    const c2 = new Phaser.Math.Vector2(x1 - 100, -50)
    const e = new Phaser.Math.Vector2(x1, 620)

    const curve = new Phaser.Curves.CubicBezier(s, c1, c2, e)

    var t = (x - x0) / (x1 - x0)
    var out = curve.getPoint(t)
    var tan = curve.getTangent(t)

    return [out.y, tan]
  }

  // preUpdate (time, delta) {
  // }

  // getX () {
  // }

  // getY () {
  // }

  // setX (x) {
  // }

  // setY (y) {
  // }

  toDef () {
    var def = super.toDef()
    def.data.nPoints = this.editor.points.length
    if (this.editor.points.length >= 2) {
      for (var i = 0; i < this.editor.points.length; i++) {
        def.data['p' + i] = this.editor.getPoint(i)
      }
    }
    return def
  }

  delete () {
    this.graphics.destroy()
    this.scene.spawner.guide = null
    super.delete()
  }

  // addHandler (handler) {
  //   this.handlers.push(handler)
  //   this.refresh()
  // }

  // insertHandler (x) {
  //   var index = this.handlers.length
  //   if (x < this.handlers[0].getX()) {
  //     index = 0
  //   } else {
  //     for (var i = 1; i < this.handlers.length; i++) {
  //       if (x >= this.handlers[i - 1].getX() && x < this.handlers[i].getX()) {
  //         index = i
  //         break
  //       }
  //     }
  //   }

  //   var temp = new GuideHandler(x, 350, this, this.scene, index)
  //   this.scene.add.existing(temp)
  //   this.handlers.splice(index, 0, temp)
  //   this.refresh()
  // }

  // deleteHandler (index) {
  //   this.handlers.splice(index, 1)
  //   this.refresh()
  // }
}
